import { render, staticRenderFns } from "./ComparativeEarnings.vue?vue&type=template&id=1c13fb8a&"
import script from "./ComparativeEarnings.vue?vue&type=script&lang=js&"
export * from "./ComparativeEarnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports